/** @format */

import {styled} from '@mui/material/styles';
import {Checkbox, TableBody, TableContainer} from '@mui/material';

import {scrollbarStyles} from 'constants/scrollbar';

import {TableVariant} from './types';

interface StyledTableContainerProps {
  variant: TableVariant;
  stickyHeader?: boolean;
  stickyFooter?: boolean;
}

export const StyledTableContainer = styled(TableContainer, {
  shouldForwardProp: prop =>
    prop !== 'variant' && prop !== 'stickyHeader' && prop !== 'stickyFooter',
})<StyledTableContainerProps>(({theme, variant, stickyHeader, stickyFooter}) => ({
  borderRadius: theme.spacing(2),
  // Sticky-шапка/подвал работают только если контейнер не имеет own scroll-context.
  // Иначе sticky прилипает к нему вместо viewport.
  ...(stickyHeader || stickyFooter ? {overflow: 'visible'} : null),

  '> div': {
    ...scrollbarStyles(theme, variant),
  },
}));

interface StyledTableBodyProps {
  variant: TableVariant;
}

export const StyledTableBody = styled(TableBody, {
  shouldForwardProp: prop => prop !== 'variant',
})<StyledTableBodyProps>(({theme, variant}) => ({
  '.MuiTableRow-root': {
    borderBottom:
      variant === 'dark'
        ? `1px solid ${theme.palette.figma_gray_dark_3?.main}`
        : `1px solid ${theme.palette.semantic_light?.surface.surface2}`,

    backgroundColor: variant === 'light' ? theme.palette.secondary.main : 'none',
  },

  '.MuiTableRow-root .MuiTableCell-root:not(:last-of-type)': {
    borderRight:
      variant === 'dark'
        ? `1px solid ${theme.palette.figma_gray_dark_3?.main}`
        : `1px solid ${theme.palette.semantic_light?.surface.surface2}`,
  },

  '.MuiTableRow-root .MuiTableCell-root': {
    color: variant === 'light' ? theme.palette.figma_gray_dark_5?.main : 'inherit',
    fontSize: variant === 'light' ? '14px' : 'inherit',
    lineHeight: variant === 'light' ? '16px' : 'inherit',
    fontWeight: variant === 'light' ? 400 : 'inherit',
  },
}));

interface StyledCheckboxProps {
  checkboxOffsetX: number;
}

export const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: prop => prop !== 'checkboxOffsetX',
})<StyledCheckboxProps>(({theme, checkboxOffsetX}) => ({
  padding: theme.spacing(1),
  color: '#547AE0',
  '&.Mui-checked, &.MuiCheckbox-indeterminate': {
    color: '#547AE0',
  },
  position: 'absolute',
  left: 0,
  top: 0,
  transform: `translateX(${checkboxOffsetX}px)`,
}));
